import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm, Controller } from "react-hook-form";
export const generalErrorMessage = "Field is required";
export const atLeastOneField = "At least one option must be selected";
export const validationSchema = Yup.object({
  card_management_feature_my_account_feature_app_enable: Yup.string().required(generalErrorMessage),
  card_management_feature_my_account_feature_required_for: Yup.array(Yup.string()).when("card_management_feature_my_account_feature_app_enable", {
    is: (value) => value && value === "Yes",
    then: () => Yup.array(Yup.string()).required(generalErrorMessage),
    otherwise: () => Yup.array().optional(),
  }),
  card_management_feature_my_account_feature_required_for_custom: Yup.string().optional(),
  card_management_feature_card_services_feature_app_enable: Yup.string().required(generalErrorMessage),
  card_management_feature_card_services_feature_required_for: Yup.array(Yup.string()).when("card_management_feature_card_services_feature_app_enable", {
    is: (value) => value && value === "Yes",
    then: () => Yup.array(Yup.string()).required(generalErrorMessage),
    otherwise: () => Yup.array().optional(),
  }),
  card_management_feature_card_services_feature_app_enable_custom: Yup.string().optional(),
  card_management_feature_card_services_card_activation_after_login: Yup.string().when("card_management_feature_card_services_feature_app_enable", {
    is: (value) => value && value === "Yes",
    then: () => Yup.string().required(generalErrorMessage),
    otherwise: () => Yup.string().optional(),
  }),
  card_management_feature_card_services_info_for_validation: Yup.array(Yup.string()).when("card_management_feature_card_services_feature_app_enable", {
    is: (value) => value && value === "Yes",
    then: () => Yup.array(Yup.string()).required(generalErrorMessage),
    otherwise: () => Yup.array().optional(),
  }),
  card_management_feature_rewards_and_cashback_feature_app_enable: Yup.string().required(generalErrorMessage),
  card_management_feature_rewards_and_cashback_feature_required_for: Yup.array(Yup.string()).when("card_management_feature_rewards_and_cashback_feature_app_enable", {
    is: (value) => value && value === "Yes",
    then: () => Yup.array(Yup.string()).required(generalErrorMessage),
    otherwise: () => Yup.array().optional(),
  }),
  card_management_feature_rewards_and_cashback_rewards_type: Yup.string().when("card_management_feature_rewards_and_cashback_feature_app_enable", {
    is: (value) => value && value === "Yes",
    then: () => Yup.string().required(generalErrorMessage),
    otherwise: () => Yup.string().optional(),
  }),
  card_management_feature_rewards_and_cashback_manual_redeem: Yup.string().when("card_management_feature_rewards_and_cashback_feature_app_enable", {
    is: (value) => value && value === "Yes",
    then: () => Yup.string().required(generalErrorMessage),
    otherwise: () => Yup.string().optional(),
  }),
  card_management_feature_rewards_and_cashback_feature_app_enable_custom: Yup.string().optional(),
  card_management_feature_credit_promotions_feature_app_enable: Yup.string().required(generalErrorMessage),
  card_management_feature_credit_promotions_feature_required_for: Yup.array(Yup.string()).when("card_management_feature_credit_promotions_feature_app_enable", {
    is: (value) => value && value === "Yes",
    then: () => Yup.array(Yup.string()).required(generalErrorMessage),
    otherwise: () => Yup.array().optional(),
  }),
  card_management_feature_credit_promotions_feature_app_enable_custom: Yup.string().optional(),
  card_management_feature_dispute_form_feature_app_enable: Yup.string().required(generalErrorMessage),
  card_management_feature_dispute_form_feature_required_for: Yup.array(Yup.string()).when("card_management_feature_dispute_form_feature_app_enable", {
    is: (value) => value && value === "Yes",
    then: () => Yup.array(Yup.string()).required(generalErrorMessage),
    otherwise: () => Yup.array().optional(),
  }),
  card_management_feature_dispute_form_feature_app_enable_custom: Yup.string().optional(),
  card_management_feature_dispute_form_dispute_options: Yup.array(Yup.string()).optional(),
  card_management_feature_dispute_form_custom_form_file: Yup.string().when("card_management_feature_dispute_form_feature_app_enable", {
    is: (value) => value && value === "Yes",
    then: () => Yup.string().nullable(),
    otherwise: () => Yup.string().nullable(),
  }),
  card_management_feature_dispute_center_feature_app_enable: Yup.string().required(generalErrorMessage),
  card_management_feature_dispute_center_feature_required_for: Yup.array(Yup.string()).when("card_management_feature_dispute_center_feature_app_enable", {
    is: (value) => value && value === "Yes",
    then: () => Yup.array(Yup.string()).required(generalErrorMessage),
    otherwise: () => Yup.array().optional(),
  }),
  card_management_feature_dispute_center_feature_app_enable_custom: Yup.string().optional(),
  card_management_feature_account_notification_feature_app_enable: Yup.string().required(generalErrorMessage),
  card_management_feature_account_notification_feature_required_for: Yup.array(Yup.string()).when("card_management_feature_account_notification_feature_app_enable", {
    is: (value) => value && value === "Yes",
    then: () => Yup.array(Yup.string()).required(generalErrorMessage),
    otherwise: () => Yup.array().optional(),
  }),
  card_management_feature_manage_pin_feature_app_enable: Yup.string().required(generalErrorMessage),
  card_management_feature_manage_pin_feature_required_for: Yup.array(Yup.string()).when("card_management_feature_manage_pin_feature_app_enable", {
    is: (value) => value && value === "Yes",
    then: () => Yup.array(Yup.string()).required(generalErrorMessage),
    otherwise: () => Yup.array().optional(),
  }),
  card_management_feature_manage_pin_info_verification_for_change_pin: Yup.array(Yup.string()).when("card_management_feature_manage_pin_feature_app_enable", {
    is: (value) => value && value === "Yes",
    then: () => Yup.array(Yup.string()).required(generalErrorMessage),
    otherwise: () => Yup.array().optional(),
  }),
  card_management_feature_manage_pin_enable_captcha: Yup.string().when("card_management_feature_manage_pin_feature_app_enable", {
    is: (value) => value && value === "Yes",
    then: () => Yup.string().required(generalErrorMessage),
    otherwise: () => Yup.string().optional(),
  }),
  card_management_feature_manage_pin_feature_app_enable_custom: Yup.string().optional(),
  card_management_feature_credit_payments_feature_app_enable: Yup.string().required(generalErrorMessage),
  card_management_feature_credit_payments_feature_required_for: Yup.array(Yup.string()).when("card_management_feature_credit_payments_feature_app_enable", {
    is: (value) => value && value === "Yes",
    then: () => Yup.array(Yup.string()).required(generalErrorMessage),
    otherwise: () => Yup.array().optional(),
  }),
  card_management_feature_credit_payments_feature_app_enable_custom: Yup.string().optional(),
  card_management_feature_credit_payments_features_data: Yup.array().of(
    Yup.object().shape({
      feature: Yup.string().optional(),
      enabled: Yup.boolean(),
      alternativeMethod: Yup.string().optional(),
    })
  ).nullable(),
  card_management_feature_spending_controls_feature_required_for: Yup.array(Yup.string()).required(generalErrorMessage),
  card_management_feature_bank_accounts_feature_app_enable: Yup.string().required(generalErrorMessage),
  card_management_feature_bank_accounts_feature_required_for: Yup.array(Yup.string()).when("card_management_feature_bank_accounts_feature_app_enable", {
    is: (value) => value && value === "Yes",
    then: () => Yup.array(Yup.string()).required(generalErrorMessage),
    otherwise: () => Yup.array().optional(),
  }),
  card_management_feature_bank_accounts_feature_app_enable_custom: Yup.string().optional(),
  card_management_feature_bank_accounts_primary_methods_for_account_setup: Yup.string().when("card_management_feature_bank_accounts_feature_app_enable", {
    is: (value) => value && value === "Yes",
    then: () => Yup.string().required(generalErrorMessage),
    otherwise: () => Yup.string().optional(),
  }),
  card_management_feature_bank_accounts_fallback_micropayment_method: Yup.string().when("card_management_feature_bank_accounts_feature_app_enable", {
    is: (value) => value && value === "Yes",
    then: () => Yup.string().required(generalErrorMessage),
    otherwise: () => Yup.string().optional(),
  }),
  card_management_feature_bill_payments_feature_app_enable: Yup.string().required(generalErrorMessage),
  card_management_feature_bill_payments_feature_required_for: Yup.array(Yup.string()).when("card_management_feature_bill_payments_feature_app_enable", {
    is: (value) => value && value === "Yes",
    then: () => Yup.array(Yup.string()).required(generalErrorMessage),
    otherwise: () => Yup.array().optional(),
  }),
  card_management_feature_bill_payments_feature_app_enable_custom: Yup.string().optional(),
  card_management_feature_wallet_provision_feature_app_enable: Yup.string().required(generalErrorMessage),
  card_management_feature_wallet_provision_digital_wallet_types: Yup.array(Yup.string()).when("card_management_feature_wallet_provision_feature_app_enable", {
    is: (value) => value && value === "Yes",
    then: () => Yup.array(Yup.string()).required(generalErrorMessage),
    otherwise: () => Yup.array().optional(),
  }),
  card_management_feature_wallet_provision_payment_networks: Yup.array(Yup.string()).when("card_management_feature_wallet_provision_feature_app_enable", {
    is: (value) => value && value === "Yes",
    then: () => Yup.array(Yup.string()).required(generalErrorMessage),
    otherwise: () => Yup.array().optional(),
  }),
  card_management_feature_manage_profile_feature_required_for: Yup.array(Yup.string()).required(generalErrorMessage),
  card_management_feature_manage_profile_info_verification_for_pin_change: Yup.array(Yup.string()).required(generalErrorMessage),
  card_management_feature_manage_profile_enable_captcha: Yup.string().required(generalErrorMessage),

  card_management_feature_manage_additional_cards_feature_app_enable: Yup.string().required(generalErrorMessage),
  card_management_feature_manage_additional_cards_feature_required_for: Yup.array(Yup.string()).when("card_management_feature_manage_additional_cards_feature_app_enable", {
    is: (value) => value && value === "Yes",
    then: () => Yup.array(Yup.string()).required(generalErrorMessage),
    otherwise: () => Yup.array().optional(),
  }),
  card_management_feature_manage_additional_cards_feature_app_enable_custom: Yup.string().optional(),
  card_management_feature_manage_access_code_feature_app_enable: Yup.string().required(generalErrorMessage),
  card_management_feature_manage_access_code_feature_required_for: Yup.array(Yup.string()).when("card_management_feature_manage_access_code_feature_app_enable", {
    is: (value) => value && value === "Yes",
    then: () => Yup.array(Yup.string()).required(generalErrorMessage),
    otherwise: () => Yup.array().optional(),
  }),
  card_management_feature_manage_access_code_features: Yup.array(Yup.string()).when("card_management_feature_manage_access_code_feature_app_enable", {
    is: (value) => value && value === "Yes",
    then: () => Yup.array(Yup.string()).required(generalErrorMessage),
    otherwise: () => Yup.array().optional(),
  }),
  card_management_feature_manage_access_code_info_verification_for_code_access: Yup.array(Yup.string()).when("card_management_feature_manage_access_code_feature_app_enable", {
    is: (value) => value && value === "Yes",
    then: () => Yup.array(Yup.string()).required(generalErrorMessage),
    otherwise: () => Yup.array().optional(),
  }),
  card_management_feature_manage_access_code_feature_app_enable_custom: Yup.string().optional(),
  card_management_feature_message_center_feature_app_enable: Yup.string().required(generalErrorMessage),
  card_management_feature_message_center_feature_required_for: Yup.array(Yup.string()).when("card_management_feature_message_center_feature_app_enable", {
    is: (value) => value && value === "Yes",
    then: () => Yup.array(Yup.string()).required(generalErrorMessage),
    otherwise: () => Yup.array().optional(),
  }),
  card_management_feature_message_center_feature_app_enable_custom: Yup.string().optional(),
  card_management_feature_additional_service: Yup.string().optional(),
});


export const fields = [
  "card_management_feature_my_account_feature_app_enable",
  "card_management_feature_my_account_feature_required_for",
  "card_management_feature_my_account_feature_required_for_custom",
  "card_management_feature_card_services_feature_app_enable",
  "card_management_feature_card_services_feature_required_for",
  "card_management_feature_card_services_feature_app_enable_custom",
  "card_management_feature_card_services_card_activation_after_login",
  "card_management_feature_card_services_info_for_validation",
  "card_management_feature_rewards_and_cashback_feature_app_enable",
  "card_management_feature_rewards_and_cashback_feature_required_for",
  "card_management_feature_rewards_and_cashback_rewards_type",
  "card_management_feature_rewards_and_cashback_manual_redeem",
  "card_management_feature_rewards_and_cashback_feature_app_enable_custom",
  "card_management_feature_credit_promotions_feature_app_enable",
  "card_management_feature_credit_promotions_feature_required_for",
  "card_management_feature_credit_promotions_feature_app_enable_custom",
  "card_management_feature_dispute_form_feature_app_enable",
  "card_management_feature_dispute_form_dispute_options",
  "card_management_feature_dispute_form_feature_required_for",
  "card_management_feature_dispute_form_feature_app_enable_custom",
  "card_management_feature_dispute_form_custom_form_file",
  "card_management_feature_dispute_center_feature_app_enable",
  "card_management_feature_dispute_center_feature_required_for",
  "card_management_feature_dispute_center_feature_app_enable_custom",
  "card_management_feature_account_notification_feature_app_enable",
  "card_management_feature_account_notification_feature_required_for",
  "card_management_feature_manage_pin_feature_app_enable",
  "card_management_feature_manage_pin_feature_required_for",
  "card_management_feature_manage_pin_info_verification_for_change_pin",
  "card_management_feature_manage_pin_enable_captcha",
  "card_management_feature_manage_pin_feature_app_enable_custom",
  "card_management_feature_credit_payments_feature_app_enable",
  "card_management_feature_credit_payments_feature_required_for",
  "card_management_feature_credit_payments_feature_app_enable_custom",
  "card_management_feature_spending_controls_feature_required_for",
  "card_management_feature_bank_accounts_feature_app_enable",
  "card_management_feature_bank_accounts_feature_required_for",
  "card_management_feature_bank_accounts_feature_app_enable_custom",
  "card_management_feature_bank_accounts_primary_methods_for_account_setup",
  "card_management_feature_bank_accounts_fallback_micropayment_method",
  'card_management_feature_bill_payments_feature_app_enable',
  "card_management_feature_bill_payments_feature_required_for",
  "card_management_feature_bill_payments_feature_app_enable_custom",
  "card_management_feature_wallet_provision_feature_app_enable",
  "card_management_feature_wallet_provision_digital_wallet_types",
  "card_management_feature_wallet_provision_payment_networks",
  "card_management_feature_manage_profile_feature_required_for",
  "card_management_feature_manage_profile_info_verification_for_pin_change",
  "card_management_feature_manage_profile_enable_captcha",
  "card_management_feature_manage_additional_cards_feature_app_enable",
  "card_management_feature_manage_additional_cards_feature_required_for",
  "card_management_feature_manage_additional_cards_feature_app_enable_custom",
  "card_management_feature_manage_access_code_feature_app_enable",
  "card_management_feature_manage_access_code_feature_required_for",
  "card_management_feature_manage_access_code_feature_app_enable_custom",
  "card_management_feature_manage_access_code_features",
  "card_management_feature_manage_access_code_info_verification_for_code_access",
  "card_management_feature_message_center_feature_app_enable",
  "card_management_feature_message_center_feature_required_for",
  "card_management_feature_message_center_feature_app_enable_custom",
  "card_management_feature_additional_service",
  "card_management_feature_credit_payments_features_data",
  // "card_management_feature_my_account_features"
];